import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TickarooWatermark } from "@nxt-shared/ui/components/TickarooWatermark";
import { globalComponents } from "./i18n.js";
/**
 * The frame for pages reached without the signed-in app shell, such as accepting an invitation or
 * signing up: the shells' gradient, the Tickaroo wordmark, and one centred column.
 */
export function EntryShell({ children }) {
    const t = globalComponents.useT();
    return (_jsx("div", { className: "min-h-dvh bg-linear-to-b from-gray-200 to-gray-50 px-4 py-10 lg:py-16", children: _jsxs("div", { className: "mx-auto flex w-full max-w-lg flex-col gap-8", children: [_jsx(TickarooWatermark, { role: "img", "aria-label": t("entryShell.wordmark"), fill: "currentColor", className: "h-6 w-auto self-start" }), _jsx("main", { className: "flex flex-col gap-4", children: children })] }) }));
}
//# sourceMappingURL=EntryShell.js.map